import { useEffect, useState } from 'react';

import { getInstalledApps } from '../../api/app-store-api';

import type { AppStoreInstalledApp } from '../../api/app-store-api';

type LoadState = { status: 'loading' } | { status: 'loaded'; apps: AppStoreInstalledApp[] } | { status: 'error' };

export const useInstalledApps = () => {
  const [loadState, setLoadState] = useState<LoadState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;
    getInstalledApps()
      .then((data) => {
        if (!cancelled) {
          setLoadState({ status: 'loaded', apps: data.installedApps });
        }
      })
      .catch(() => {
        if (!cancelled) {
          setLoadState({ status: 'error' });
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return loadState;
};
